import { IconCheckCircle } from '@nxsys/components/AppIconSvg';
import { Button, notification } from 'antd';
// import { IconSuccess, IconWarning } from '@nxsys/components/AppIconSvg';

type NotificationType = 'success' | 'info' | 'warning' | 'error';

export type ToastAction = { label: string; onClick: () => void };

const recentMessages = new Map<string, number>();
const DEDUP_WINDOW_MS = 3000;

function deduplicateMessage(msg: string): string {
  if (!msg || !msg.includes(', ')) return msg;
  const parts = msg.split(', ').map((s) => s.trim()).filter(Boolean);
  if (parts.length <= 1) return msg;
  const counts = new Map<string, number>();
  for (const part of parts) {
    counts.set(part, (counts.get(part) || 0) + 1);
  }
  if (counts.size === parts.length) return msg;
  return [...counts.entries()]
    .map(([m, count]) => (count > 1 ? `${m} (x${count})` : m))
    .join(', ');
}

export function showToast({
  type = 'info',
  message = '',
  duration = 3,
  action,

  ...rest
}: {
  type: NotificationType;
  message: string;
  duration?: number;
  /** Renders an inline action button (e.g. billing autosave "Undo"). */
  action?: ToastAction;
}) {
  message = deduplicateMessage(message);

  const dedupKey = `${type}:${message}`;
  const now = Date.now();
  const lastShown = recentMessages.get(dedupKey);
  if (lastShown && now - lastShown < DEDUP_WINDOW_MS) {
    return;
  }
  recentMessages.set(dedupKey, now);

  if (recentMessages.size > 50) {
    for (const [k, ts] of recentMessages) {
      if (now - ts >= DEDUP_WINDOW_MS) recentMessages.delete(k);
    }
  }

  const key = `open${now}`;
  notification.config({
    placement: 'topRight',
    duration: 3,
    closeIcon: false,
    showProgress: false,
    maxCount: 3,
  });
  notification[type]({
    key,
    type,
    message,
    duration,
    // icon: IconSuccess,
    icon:
      type === 'success' ? (
        <IconCheckCircle width={20} height={20} />
      ) : undefined,
    btn: action ? (
      <Button
        type="link"
        size="small"
        onClick={() => {
          action.onClick();
          notification.destroy(key);
        }}
      >
        {action.label}
      </Button>
    ) : undefined,
    ...rest,
  });
}
